import { ACTIVE_STATUSES } from '../constants';
import { BatchStatus, SortingBatch } from '../types';

/** 是否还能新增包牌 / 结束分拣（仅已创建、分拣中） */
export const isActiveStatus = (status: BatchStatus): boolean => ACTIVE_STATUSES.includes(status);

export const canCreateBags = (status: BatchStatus): boolean => isActiveStatus(status);

export const canEndSorting = (status: BatchStatus): boolean => isActiveStatus(status);

/**
 * 不可操作时的提示类型：分拣结束 → 不能新增包牌；已完成 / 已取消 → 已终结。
 */
export const blockedReasonOf = (status: BatchStatus): 'sortingEnded' | 'terminated' | null => {
    if (isActiveStatus(status)) return null;
    return status === 'SORTING_ENDED' ? 'sortingEnded' : 'terminated';
};

/**
 * 批次是否已有包牌或包裹（有则不可取消）。
 * @param currentBags 批次当前包牌列表数（含整包移入的包牌）
 */
export const hasBagsOrParcels = (b: SortingBatch, currentBags = 0): boolean =>
    (b.parcels || 0) > 0 || (b.createdBags || b.packedBags || 0) > 0 || currentBags > 0;

/**
 * 取消批次校验：任一所选批次含包牌或包裹则整体拒绝（与原型一致，不做部分取消）。
 * @param bagCountOf 批次当前包牌列表数，用于识别整包移入了包牌的空批次
 */
export const checkCancel = (
    selected: SortingBatch[],
    bagCountOf: (b: SortingBatch) => number = () => 0,
): { allowed: boolean; rejected: SortingBatch[] } => {
    const rejected = selected.filter((b) => hasBagsOrParcels(b, bagCountOf(b)));
    return { allowed: selected.length > 0 && rejected.length === 0, rejected };
};

/** 结束分拣实际生效的批次（已创建 / 分拣中） */
export const endSortingTargets = <T extends { status: BatchStatus }>(selected: T[]): T[] => selected.filter((b) => canEndSorting(b.status));
